/**
 * @generated SignedSource<<5169ed06b7bc223e6397da9b334c96ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TransactionTypeEnum = "ACCEPT_OFFER" | "ACCEPT_SWAP" | "APPROVE_COLLECTION" | "ASSETS_RECEIVED" | "ASSETS_SENT" | "BRIDGE_DEPOSIT" | "BRIDGE_WITHDRAW" | "BULK_ACCEPT_OFFER" | "BULK_OFFER_ACCEPTED" | "BULK_PURCHASE" | "BULK_RECEIVED" | "BULK_SALE" | "BULK_SENT" | "BUY_NOW" | "CANCEL_ALL_ORDERS" | "CANCEL_ASK" | "CANCEL_BID" | "CANCEL_COLLECTION_OFFFER" | "CANCEL_ORDERS" | "CANCEL_SWAP" | "CONFIGURE_DROP" | "CREATE_SEADROP_CONTRACT" | "ERC20_APPROVE" | "ERC20_RECEIVED" | "ERC20_SENT" | "ERC20_SWAP_DEPOSIT" | "ERC20_SWAP_WITHDRAW" | "MINT" | "MINT_ALLOWLIST" | "NATIVE_RECEIVED" | "NATIVE_SENT" | "NFT_RECEIVED" | "NFT_SENT" | "OFFER_ACCEPTED" | "OPENSEA_PRO_TRADE" | "REDEEM" | "SALE" | "SWAP_COMPLETE" | "UNKNOWN" | "UNWRAP" | "WRAP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type Transaction_metadata$data = {
  readonly type: TransactionTypeEnum;
  readonly " $fragmentSpreads": FragmentRefs<"AcceptOffer_metadata" | "ApproveCollection_metadata" | "ApproveCurrency_metadata" | "BulkTransfer_metadata" | "CancelDeal_metadata" | "CancelOrder_metadata" | "ConfigureDrop_metadata" | "DealAccept_metadata" | "Mint_metadata" | "OfferAccepted_metadata" | "PaymentAssetTransfer_metadata" | "Purchase_metadata" | "Receive_metadata" | "Redeem_metadata" | "Sale_metadata" | "Swap_metadata" | "Transfer_metadata" | "Unwrap_metadata" | "Wrap_metadata">;
  readonly " $fragmentType": "Transaction_metadata";
};
export type Transaction_metadata$key = {
  readonly " $data"?: Transaction_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"Transaction_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Transaction_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AcceptOffer_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfferAccepted_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DealAccept_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApproveCollection_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApproveCurrency_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BulkTransfer_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelOrder_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CancelDeal_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentAssetTransfer_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Purchase_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Sale_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Mint_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Transfer_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Unwrap_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Wrap_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Redeem_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConfigureDrop_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Swap_metadata"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Receive_metadata"
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};

(node as any).hash = "91f83a14f041450e8949751ee1f6b32a";

export default node;
